'use client';

import JotFormEmbed from '@/layers/presentation/components/ui/JotFormEmbed';
import {
  trackGAEvent,
  trackGoogleAdsConversion,
} from '@/layers/presentation/components/utils/GAEventTracking';
import { GOOGLE_ADS_CONVERSIONS } from '@/layers/presentation/components/utils/GoogleAnalytics';
import logger from '@/layers/support/monitoring/logger';

const LOG_MODULE = '[Pages / About / Ask Question]';

/**
 * Client portion of the contact-us page — the JotForm embed + its submit
 * tracking. Extracted so the server `page.tsx` can export metadata.
 */
export default function ContactUsForm() {
  const handleSubmit = () => {
    logger.debug(`${LOG_MODULE} onSubmit`);
    trackGAEvent('contact_submit', { lead_stage: 'micro', form_type: 'contact' });
    trackGoogleAdsConversion(GOOGLE_ADS_CONVERSIONS.SUBMIT_LEAD_FORM);
  };

  return (
    <JotFormEmbed jotformId="243214051311438" onSubmit={handleSubmit} width="100%" height="700px" />
  );
}
